import {
  FETCH_TRENDING_REQUEST,
  FETCH_TRENDING_SUCCESS,
  FETCH_TRENDING_FAILURE,
} from "../actions/newArrivalActions";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const newArrivalReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRENDING_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_TRENDING_SUCCESS:
      return { ...state, loading: false, items: action.payload };
    case FETCH_TRENDING_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

